// ── OMDB API Integration ──────────────────────────────────────
// Free tier: 1,000 requests/day
// Docs: https://omdbapi.com

const OMDB_KEY = 'aeb7aa93';
const BASE     = 'https://www.omdbapi.com';

// Search films by title — returns array of results
export const searchOMDB = async (query) => {
  if (!query || query.length < 2) return [];
  try {
    const res  = await fetch(`${BASE}/?apikey=${OMDB_KEY}&s=${encodeURIComponent(query)}&type=movie`);
    const data = await res.json();
    if (data.Response === 'False') return [];
    // Also search series
    const res2  = await fetch(`${BASE}/?apikey=${OMDB_KEY}&s=${encodeURIComponent(query)}&type=series`);
    const data2 = await res2.json();
    const series = data2.Response === 'True' ? data2.Search || [] : [];
    return [...(data.Search || []), ...series];
  } catch { return []; }
};

// Get full details for a single film by IMDB ID
export const getOMDBFilm = async (imdbId) => {
  if (!imdbId) return null;
  try {
    const res  = await fetch(`${BASE}/?apikey=${OMDB_KEY}&i=${imdbId}&plot=full`);
    const data = await res.json();
    if (data.Response === 'False') return null;
    return data;
  } catch { return null; }
};

// Get full details by title + year
export const getOMDBByTitle = async (title, year) => {
  if (!title) return null;
  try {
    const yearParam = year ? `&y=${year}` : '';
    const res  = await fetch(`${BASE}/?apikey=${OMDB_KEY}&t=${encodeURIComponent(title)}${yearParam}&plot=full`);
    const data = await res.json();
    if (data.Response === 'False') return null;
    return data;
  } catch { return null; }
};

// Convert OMDB film data to Critiqr film format
export const omdbToFilm = (omdb) => ({
  id:          `omdb_${omdb.imdbID}`,
  imdb_id:     omdb.imdbID,
  title:       omdb.Title || 'Unknown Title',
  year:        parseInt(omdb.Year) || null,
  language:    (omdb.Language && omdb.Language !== 'N/A') ? omdb.Language.split(',')[0].trim() : 'Unknown',
  description: (omdb.Plot && omdb.Plot !== 'N/A') ? omdb.Plot : '',
  poster_url:  (omdb.Poster && omdb.Poster !== 'N/A') ? omdb.Poster : null,
  poster_emoji:'🎬',
  imdb_rating: (omdb.imdbRating && omdb.imdbRating !== 'N/A') ? parseFloat(omdb.imdbRating) : null,
  genres:      (omdb.Genre && omdb.Genre !== 'N/A') ? omdb.Genre.split(',').map(g => g.trim()) : [],
  type:        omdb.Type === 'series' ? 'series' : 'movie',
  director:    (omdb.Director && omdb.Director !== 'N/A') ? omdb.Director : null,
  film_cast:   (omdb.Actors && omdb.Actors !== 'N/A') ? omdb.Actors.split(',').map(a => a.trim()) : [],
  runtime:     (omdb.Runtime && omdb.Runtime !== 'N/A') ? omdb.Runtime : null,
  country:     (omdb.Country && omdb.Country !== 'N/A') ? omdb.Country : null,
  awards:      (omdb.Awards && omdb.Awards !== 'N/A') ? omdb.Awards : null,
  rated:       (omdb.Rated && omdb.Rated !== 'N/A') ? omdb.Rated : null,
  _fromOMDB:   true,
});
